import OrderSlice from './OrderSlice';

export default OrderSlice.actions;
